/**
 * The set of tables/entities that support saved (table) filters.
 *
 * Canonical replacement for the Hasura-generated `TableFilterReferenceEnum`.
 * Owned here in the shared `tables` package because the concept is cross-cutting
 * across many frontend tables; the `table_filters` data is owned by org-settings.
 */
export const TableFilterReference = {
  AGREEMENT: 'AGREEMENT',
  ASSESSMENT: 'ASSESSMENT',
  BUDGET: 'BUDGET',
  DOCUMENT: 'DOCUMENT',
  PRODUCT_BRANDS: 'PRODUCT_BRANDS',
  REMINDER: 'REMINDER',
  RENEWAL: 'RENEWAL',
  REQUEST: 'REQUEST',
  RISK: 'RISK',
  SUPPLIER: 'SUPPLIER',
  TASK: 'TASK',
  USER: 'USER',
} as const

export type TableFilterReference = (typeof TableFilterReference)[keyof typeof TableFilterReference]
